import {
  getFirestore,
  connectFirestoreEmulator,
  doc,
  collection,
  query,
  where,
  orderBy,
  limit,
  getDoc,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  startAfter,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  type Firestore,
  type DocumentReference,
  type CollectionReference,
  type DocumentData
} from 'firebase/firestore'
import { getFirebaseApp } from './app'
import { requireProcessEnv, useFirebaseEmulator } from './env'

let dbSingleton: Firestore | null = null
let firestoreEmulatorConnected = false

function maybeConnectFirestoreEmulator(db: Firestore): void {
  if (!useFirebaseEmulator() || firestoreEmulatorConnected) return
  const hostPort = requireProcessEnv('VUE_APP_FIREBASE_FIRESTORE_EMULATOR_HOST')
  const [host, portStr] = hostPort.split(':')
  if (!host || !portStr) {
    throw new Error(
      `[firebase] VUE_APP_FIREBASE_FIRESTORE_EMULATOR_HOST must be host:port (got ${hostPort})`
    )
  }
  connectFirestoreEmulator(db, host, Number(portStr))
  firestoreEmulatorConnected = true
}

export function getFirebaseDb(): Firestore {
  if (dbSingleton) {
    maybeConnectFirestoreEmulator(dbSingleton)
    return dbSingleton
  }
  dbSingleton = getFirestore(getFirebaseApp())
  maybeConnectFirestoreEmulator(dbSingleton)
  return dbSingleton
}

/** `userdata/uid/backups` のようなパス文字列を DocumentReference に */
export function pathDoc(
  db: Firestore,
  path: string,
  ...extra: string[]
): DocumentReference<DocumentData> {
  const parts = [...path.split('/').filter(Boolean), ...extra]
  return doc(db, parts[0], ...parts.slice(1))
}

/** パス文字列を CollectionReference に */
export function pathCollection(
  db: Firestore,
  path: string
): CollectionReference<DocumentData> {
  const parts = path.split('/').filter(Boolean)
  return collection(db, parts[0], ...parts.slice(1))
}

export {
  query,
  where,
  orderBy,
  limit,
  getDoc,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  startAfter,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  doc,
  collection
}

export type { Firestore, DocumentReference, CollectionReference }
